import { GenericActionResponse } from "../@types/index";
import { RotaEdicaoRequest, RotasApiResponse } from "../@types/rotas";
import apiAutenticacao from "./api-autenticacao.service";

export function obterRotas(): Promise<RotasApiResponse> {
  return apiAutenticacao.get('/configuracoes/rotas');
}

export function obterRotasPorTextoDeBusca(textoBusca: string): Promise<RotasApiResponse> {
  return apiAutenticacao.get(`/configuracoes/rotas/buscar-por-campos?textoDeBusca=${textoBusca}`);
}

export function cadastrarRota(rota: RotaEdicaoRequest): Promise<GenericActionResponse> {
  return apiAutenticacao.post("/configuracoes/rotas/", rota);
}

export function atualizarRota(id: number, rota: RotaEdicaoRequest): Promise<GenericActionResponse> {
  return apiAutenticacao.put(`/configuracoes/rotas/${id}`, rota);
}

export function excluirRota(id: number): Promise<GenericActionResponse> {
  return apiAutenticacao.delete(`/configuracoes/rotas/${id}`);
}

export function obterPermissoesRota(id: number): Promise<RotasApiResponse> {
  return apiAutenticacao.get(`/configuracoes/rotas/${id}`);
}